import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import {TriggerDatasetService} from "@app/workflow-common/services/trigger-dataset.service";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DagSourceModel, InitialBlock, InitialBlockInterface} from "@app/workflow-common/services/DagSourceModel";
import {ConfirmModalConfig} from "@app/interfaces/common-modal-popups";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-trigger-condition-panel',
    templateUrl: './trigger-condition-panel.component.html',
    styles: [`.add-action-btn {padding: 10px 0 0 10px;}`]
})
export class TriggerConditionPanelComponent implements OnInit {

    // initial states
    title: string;
    fields: any[];
    objectName: string;
    workflowType: string;
    rules: any[] = [];
    dagSourceModel: DagSourceModel;
    isEdit: boolean = false;

    // component vars
    form: FormGroup;
    public onClose: Subject<any>;
    select2OptionsFields: any = {};
    select2ConfigOperator: any = {
        minimumResultsForSearch: -1
    };
    fieldsAsObject: { [key: string]: any };
    isGroupTypeField: boolean = false;
    groupFields: any[] = [];
    operators:object = {};
    deleteConfirmModalConfig: ConfirmModalConfig;
    select2DataFunction = (item) => { return item.text; };
    select2FieldInstance: object = {};
    select2OperatorInstance: object = {};
    isFormSubmitted: boolean = false;
    blockId: string = 'cs_initializer';

    constructor(
      public modalRef: BsModalRef,
      private triggerService: TriggerDatasetService,
      private _formBuilder: FormBuilder,
      private _translateService: TranslateService,
    ) { }
    selectedField = []

    ngOnInit() {
        this.onClose = new Subject();
        this.operators = this.triggerService.getOperators();
        this.prepareFieldsAsObject();
        this.form = this._formBuilder.group({
            mainObjectName: new FormControl(this.objectName, [Validators.required]),
            conditions: new FormControl('and'),
            rules: this._formBuilder.array([]),
        });
        if(this.rules.length == 0) {
           this.addRule();
        }
        else {
            this.rules.forEach( rule => {
                this.addRule(rule)
                this.selectedField.push(rule.col_name)
            });
        }

        this.form.valueChanges.subscribe((value)=>{
            this.selectedField = [];

            value.rules.forEach((rule)=>{
                this.selectedField.push(rule.col_name)
            });
            console.log(this.selectedField)
        })

        this.deleteConfirmModalConfig = {
            showModal: false,
            modalType: 'confirm',
            title: 'Dummy',
            actionText: 'DELETE',
            itemText: 'DELETE',
            confirmBtnText: 'DELETE',
            confirmBtnType: 'DELETE',
            closeText: 'cancel',
            confirmBxValidationMsg: this._translateService.instant('confirmation.warning.text', {word:'DELETE',message:'remove the automation'}),
            message: { warningTxt:  'Delete.Automation.Warning.Message', helpTxtList: ['Delete.Automation.Confirmation.Message']},
            defaultTextMessage: false,
            doAction: this.removeRuleCondition.bind(this)
        };
    }

    prepareFieldsAsObject() {
        this.isGroupTypeField = this.dagSourceModel.isGroupField();
        this.groupFields = this.dagSourceModel.getGroupFields();
        // this.fieldsAsObject = this.dagSourceModel.getFieldMetadata();
        // if(this.form.get('mainObjectName').value != '') {
        // const fields = [...this.fields];
        this.fieldsAsObject = Object.values(this.dagSourceModel.getFieldMetadata()).reduce( (acc, current ) => {
            const keyName = current['col_name'];
            if(!current['fieldType']) {
                current['fieldType'] = 'static';
            }
            if(!current['pageType']) {
                current['pageType'] = '';
            }
            acc[keyName]  = current;
            return acc;
        }, {});
        // console.log('this.dagSourceModel.getFieldMetadata()', this.dagSourceModel.getFieldMetadata(), this.fieldsAsObject)
    }

    get formRules() : FormArray {
        return this.form.controls.rules as FormArray;
    }

    onChangeField(value:any, index:number) {
        let keyName = 'field_' + index;
        const formRules: FormArray = <FormArray>this.formRules;

        formRules.controls[index].get('type').setValue(this.fieldsAsObject[value]['type']);
        formRules.controls[index].get('input').setValue(this.fieldsAsObject[value]['input']);
        formRules.controls[index].get('text').setValue(this.fieldsAsObject[value]['text']);
        formRules.controls[index].get('fieldType').setValue(this.fieldsAsObject[value]['fieldType']);
        formRules.controls[index].get('pageType').setValue(this.fieldsAsObject[value]['pageType']);

        formRules.controls[index].get('operator').setValue(this.fieldsAsObject[value]['operators'][0]);
        if(this.select2OperatorInstance.hasOwnProperty(keyName)) {
            this.select2OperatorInstance[keyName].select2('val', this.fieldsAsObject[value]['operators'][0]);
        }

        formRules.controls[index].get('value').setValue('');
        if(this.select2FieldInstance.hasOwnProperty(keyName)) {
            this.select2FieldInstance[keyName].select2('val', '');
        }
    }

    addRule(ruleItem:any=null) {
        const formRules = this.form.controls.rules as FormArray;
        let rule = {
            col_name: '',
            input: '',
            operator: 'equal',
            text: '',
            type: '',
            value: '',
            fieldType: 'static',
            pageType: '',
            templateId: '',
        };

        if (ruleItem) {
            rule['col_name'] = ruleItem['col_name'];
            rule['input'] = ruleItem['input'];
            rule['operator'] = ruleItem['operator'];
            rule['text'] = ruleItem['text'];
            rule['type'] = ruleItem['type'];
            rule['value'] = ruleItem['value'];
            rule['fieldType'] = !ruleItem['fieldType'] ? 'static' : ruleItem['fieldType'];
            rule['pageType'] = !ruleItem['pageType'] ? '' : ruleItem['pageType'];
            rule['templateId'] = !ruleItem['templateId'] ? '' : ruleItem['templateId'];
        }
        formRules.push(this._formBuilder.group({
            col_name: new FormControl(rule['col_name'], [Validators.required]),
            operator: new FormControl(rule.operator, [Validators.required]),
            value: new FormControl(rule.value, [Validators.required]),
            type: new FormControl(rule.type),
            input: new FormControl(rule.input),
            text: new FormControl(rule.text),
            fieldType: new FormControl(rule.fieldType),
            pageType: new FormControl(rule.pageType),
            templateId: new FormControl(rule.templateId)
        }));
    }

    removeRuleCondition(index: number, cb) {
        const control = <FormArray>this.form.controls['rules'];
        control.removeAt(index);
        cb('SUCCESS');
    }

    setSelect2OperatorInstance(instance, index:number) {
        let keyName = 'field_' + index;
        this.select2OperatorInstance[keyName] = instance;
    }

    setSelect2InstanceFieldValue(instance, index:number, isMultiple:boolean=false) {
        let keyName = isMultiple ? 'field_multiple_'+index : 'field_' + index;
        this.select2FieldInstance[keyName] = instance;
    }

    onSelectMultipleSelect(value:any, index:number) {
        const formRules: FormArray = <FormArray>this.formRules;
        formRules.controls[index].get('value').setValue(value);
    }

    onChangeOperator(value:any, index:number) {
        let keyName;
        const formRules: FormArray = <FormArray>this.formRules;
        formRules.controls[index].get('value').setValue('');
        if(value == 'in' || value == 'not_in')
            keyName = 'field_' + index;
        else
            keyName = 'field_multiple_'+index;
        if(this.select2FieldInstance.hasOwnProperty(keyName))
            this.select2FieldInstance[keyName].select2('destroy');
    }

    onBeforeRemove(index:number) {
        let nthCondition = (index+1);
        this.deleteConfirmModalConfig.title = this._translateService.instant('Delete.Trigger.Condition', {nth: nthCondition});
        this.deleteConfirmModalConfig.confirmBxValidationMsg = this._translateService.instant('confirmation.warning.text', {word:'DELETE',message:'remove the condition '+nthCondition});
        this.deleteConfirmModalConfig.actionArg = index;
        this.deleteConfirmModalConfig.showModal=true;
    }

    onCloseConfirmation() {
        this.deleteConfirmModalConfig.showModal=false;
    }
    // removeUsedRuleCondition(){
    //     this.currentFields = this.fields;
    //     this.form.value.rules.forEach( rule => this.removeColumnFromFields(rule.col_name));
    // }
    // removeColumnFromFields(col_name: any){
    //     let Index: any;
    //     Object.entries(this.currentFields).forEach( ([key,objectFields ]) => {
    //         Index = objectFields.findIndex(field=>
    //                 field.col_name == col_name
    //             );
    //         if(Index >= 0){
    //             // this.currentFields[key].splice(Index,1);
    //         }
    //     });
    // }
    save() {
        this.isFormSubmitted = true;
        const {mainObjectName, rules, conditions} = this.form.value;
        const initBlockData:InitialBlockInterface = new InitialBlock(
            this.blockId,
            0,
            'initializer',
            conditions,
            rules,
            mainObjectName
        );
        this.onClose.next({
            action: this.isEdit ? 'edit': 'add',
            isEdit: this.isEdit,
            node: initBlockData
        });
    }

    onCloseModal() {
        this.onClose.next({
            action: 'close'
        });
        this.modalRef.hide();
    }

}
